<app-dashboard-card
	title="Tyalls Audit Summary"
	icon="pi pi-chart-bar"
	[featured]="true"
>
	<div *ngIf="loading" class="dashboard-state">
		Loading audit summary...
	</div>

	<div *ngIf="!loading && error" class="dashboard-state dashboard-state-error">
		Unable to load audit summary.
	</div>

	<div
		*ngIf="!loading && !error && dataStatus === 'WAITING'"
		class="dashboard-state"
	>
		Audit data is still being processed for the selected period.
	</div>

	<div
		*ngIf="!loading && !error && dataStatus === 'UNAVAILABLE'"
		class="dashboard-state"
	>
		Audit data is unavailable for the selected period.
	</div>

	<ng-container
		*ngIf="
			!loading &&
			!error &&
			dataStatus !== 'WAITING' &&
			dataStatus !== 'UNAVAILABLE' &&
			summary
		"
	>
		<div class="audit-table-wrapper">
			<table class="audit-table">
				<thead>
				<tr>
					<th>Risk</th>
					<th>Day</th>
					<th>MTD (AVG)</th>
				</tr>
				</thead>

				<tbody>
				<tr class="audit-financial-row">
					<td>
						<div class="audit-risk-label">
							<span class="audit-risk-indicator audit-risk-financial"></span>
							<span>Total Financial Risk</span>
						</div>
					</td>

					<td class="audit-day-value">
						{{ formatCurrency(summary.financialRiskValue) }}
					</td>

					<td>
						{{ formatCurrency(summary.financialRiskMtdAverage) }}
					</td>
				</tr>

				<tr class="audit-operations-row">
					<td>
						<div class="audit-risk-label">
							<span class="audit-risk-indicator audit-risk-operations"></span>
							<span>Total Operations Risk</span>
						</div>
					</td>

					<td class="audit-day-value">
						{{ summary.operationsRiskCount | number: '1.0-0' }}
					</td>

					<td>
						{{ formatAverage(summary.operationsRiskMtdAverage) }}
					</td>
				</tr>
				</tbody>
			</table>
		</div>
	</ng-container>

	<div
		*ngIf="
			!loading &&
			!error &&
			dataStatus !== 'WAITING' &&
			dataStatus !== 'UNAVAILABLE' &&
			!summary
		"
		class="dashboard-state"
	>
		Audit data is unavailable for the selected period.
	</div>
</app-dashboard-card>
